import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2";
import "../ModalAlerta/ModalAlerta.css";

export interface SimpleDialogProps {
	titulo?: string;
	tituloBotao?: string;
	tituloConfirmar?: string;
	texto?: string;
	dataAlteracao?: string;
	open: boolean;
	onClose: () => void;
	onClick?: () => void;
}

function ModalAlerta(props: SimpleDialogProps) {
	const { onClose, open } = props;

	const handleClose = () => {
		onClose();
	};

	const handleClick = () => {
		onClose();
	};

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-usuario">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							<div className="usuario-data">
								<b className="user">Sua sessão expira em 10 Minutos</b>
							</div>
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo="Fechar"
							cor="#0946B8"
							onClick={handleClick}
						/>
					</DialogActions>
				</div>
			</Dialog>
		</div>
	);
}

export default ModalAlerta;
